export const ESignAgreements = {
  "loadingTip": "Loading Envelope...",
  "requestSignatures": "Request Signatures",
  "tabs": {
    "AllAgreements": "All agreements",
    "WaitingForYou": "Waiting for you",
    "WaitingForOthers": "Waiting for others",
    "Draft": "Draft",
    "Completed": "Completed"
  },
  "filters": {
    "selectFilterTip": "Filters",
    "selectFilterItems": {
      "DRAFT": "DRAFT",
      "SHARED": "SHARED",
      "PARTIALLY_SIGNED": "PARTIALLY SIGNED",
      "EXECUTED": "EXECUTED",
      "CANCELLED": "CANCELLED",
      "EXPIRED": "EXPIRED"
    },
    "searchTip": "Search by Envelope or Recipient Name"
  },
  "table": {
    "columns": {
      "name": "Name",
      "recipientName": "Recipient's Name",
      "actions": "Actions",
      "dateSent": "Date Sent",
      "status": "Status"
    },
    "expandedRow": {
      "Author": "Author:",
      "Documents": "Documents:"
    },
    "envelopeStatus": {
      "DRAFT": "DRAFT",
      "SHARED": "SHARED",
      "PARTIALLY_SIGNED": "PARTIALLY SIGNED",
      "EXECUTED": "EXECUTED",
      "CANCELLED": "CANCELLED",
      "EXPIRED": "EXPIRED"
    },
    "recipientCount": "{count} People",
    "downloadPDFTip": "Download PDF",
    "noAgreements": "No agreements"
  }
}